import { checkAndUpdateToken } from './auth';
import { SET_EVENTS_CALENDAR, SET_EVENTS_CALENDAR_LOADING } from './types';
import { BACKEND_URL_PREFIX } from '../utils/const';
import { buildDefaultHeaders } from './helper';
import { createNotification } from '../components/notifications/notifications';

export const getEventsCalendar = (year, month) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_EVENTS_CALENDAR_LOADING, payload: true });
    try {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/events/calendar?year=${year}&month=${month}`,
        buildDefaultHeaders(getState)
      );
      const result = await response.json();
      if (response.ok) {
        dispatch({ type: SET_EVENTS_CALENDAR, payload: result });
      } else {
        createNotification('error', result.error);
      }
    } catch (err) {
    } finally {
      dispatch({ type: SET_EVENTS_CALENDAR_LOADING, payload: false });
    }
  }
};
